import React from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { ConsequenceDetailsViewProps } from "models/propTypes/todoPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const ConsequenceDetailsView: React.ForwardRefRenderFunction<FormHandles, ConsequenceDetailsViewProps> = (
  props,
  ref
) => {
  const { consequences } = props;

  return (
    <Grid container className={cssExports.consequenceDetailContainer}>
      {consequences.map((c) => (
        <Grid container spacing={2} className={cssExports.consequenceDetailRow}>
          {c.title ? (
            <Grid container className={cssExports.consequenceDetailTitle}>
              {c.title}
            </Grid>
          ) : (
            <></>
          )}
          {c.description ? (
            <Grid container className={cssExports.consequenceDetailDescription}>
              {c.description}
            </Grid>
          ) : (
            <></>
          )}
          <Grid container>
            {c?.associatedCosts?.map((cost) => (
              <Grid container>
                <Grid item className={cssExports.consequenceDetailAmountDescription}>
                  {cost.description ?? ""}
                </Grid>
                <Grid item xs className={cssExports.consequenceDetailAmount}>
                  {cost.amountWithUnit ?? ""}
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default React.forwardRef(ConsequenceDetailsView);
